import React, { useState } from "react";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { CasinoProviders } from "../../lib/data";
import ModalWrapper from "../../containers/ModalWrapper";
import { APP_CONST } from "../../config/const";

const sidebarLinks = [
  { name: "All Live Games", href: "/home" },
  { name: "Ezugi", href: CasinoProviders["ezugi"]?.href },
  { name: "Evolution", href: CasinoProviders["evolution"]?.href },
  { name: "Slots", href: "/slots" },
  { name: "Aero", href: "/casino/aggapturbogames-aero-u9978" },
  { name: "Promotions", href: "/promotions" },
  // { name: "Sports", href: "/spmsports/live" },
  { name: "XPG", href: "/casino/xpg" },
  // { name: "Vivo", href: "/casino/vivo" },
  { name: "Qtech", href: "/casino/qtech" },
  { name: "Worldcasino", href: "/casino/worldcasino" },
  { name: "Supernowa", href: "/casino/supernowa" },
  // { name: "Sports", href: "/spmsports/cricket" },
  // { name: "Sportsbook", href: "/betby" },
  // { name: "Sportsbook 2", href: "/sportsbook2" },
  // { name: "Kingmaker", href: "/kingmaker" },
  // { name: "Pragmaticplay", href: "/casino/pragmaticplay" },
  // { name: "Onlyplay", href: "/casino/onlyplay" },
];

const LeftBarSports = () => {
  const { isAuth } = useSelector((state) => state.auth);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const handleModalShow = () => setShowAuthModal(true);

  return (
    <>
      <div className="leftbarSec d-xl-none">
        <ul>
          {sidebarLinks.map(({ name, href }, index) => (
            <li key={index}>
              {isAuth ? (
                <NavLink to={href} activeClassName="active">
                  {name}
                </NavLink>
              ) : (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleModalShow();
                  }}>
                  {name}
                </a>
              )}
            </li>
          ))}
        </ul>
      </div>

      {showAuthModal && (
        <ModalWrapper
          defaultShow={APP_CONST.AUTH_MODAL.LOGIN}
          setShowAuthModals={setShowAuthModal}
        />
      )}
    </>
  );
};

export default LeftBarSports;
